export default __webpack_public_path__ + "static/media/benefit_8@2x.2147c872.png";